import {combineReducers} from 'redux';

import {reducer as surveyResponseReducer} from "./reducers/surveyResponse/reducer";
import {reducer as questionResponsesReducer} from "./reducers/questionResponses/reducer";
import {reducer as surveyReducer} from "./reducers/survey/reducer";
import {reducer as pagesReducer} from "./reducers/pages/reducer";
import {reducer as progressReducer} from "./reducers/progress/reducer";
import {reducer as timeMeasuringReducer} from "./reducers/timeMeasuring/reducer";
import {reducer as pageReducer} from "./reducers/page/reducer";
import {reducer as userReducer} from "./reducers/user/reducer";
import {reducer as surveyNavReducer} from "./reducers/surveyNav/reducer";

export default combineReducers({
  surveyResponse: surveyResponseReducer,
  questionResponses: questionResponsesReducer,
  survey: surveyReducer,
  pages: pagesReducer,
  progress: progressReducer,
  timeMeasuring: timeMeasuringReducer,
  page: pageReducer,
  user: userReducer,
  surveyNav: surveyNavReducer,
});
